import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import withHistory from 'mixins/with-history';
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function BrowseDesigns() {
    this.defaultAttrs({
        baseUrl: null,
        xhrUrl: null,
        filterTypes: null,
        filters: {},
    });

    this.after('initialize', function() {
        this.on(document, 'uiNeedsBrowseDesigns', this.getBrowseDesigns);

        this.on(document, 'uiInitFilters', this.initFilters);
        this.on(document, 'uiAddFilters', this.addFilters);
        this.on(document, 'uiRemoveFilters', this.removeFilters);
        this.on(document, 'uiRemoveAllFilters', this.removeAllFilters);
        this.on(document, 'uiHasFilterTitles', this.replaceFilters);

        this.on(window, 'popstate', this.historyPopped);
    });

    this.getBrowseDesigns = function(event, context) {
        const preventScrollTop = !!(context && context.preventScrollTop);
        const hideSpinner = !!(context && context.hideSpinner);
        if (!hideSpinner) {
            $(document).trigger('dataBrowseStarted');
            $(document).trigger('dataPaginationUpdate', { pagination: '' });
        }
        const filterByLikesEnabled = this.filterByLikesEnabled();
        $.ajax({
            type: 'GET',
            url: this.attr.xhrUrl,
            data: this.makeQueryString(),
            headers: {
                Accept: 'application/json',
            },
            success(data) {
                $(document).trigger('dataBrowseDesignsSuccess', {
                    designs: data.designs,
                    filterByLikesEnabled,
                });

                // Custom event to update ddo collection
                window.dispatchEvent(
                    new CustomEvent('newDdoDesignCollectionAvailable', {
                        detail: JSON.parse(data.ddo_design_collection),
                    })
                );

                $(document).trigger('filteredDesignsCountUpdate', {
                    filtered_designs_count: JSON.parse(
                        data.ddo_design_collection
                    ).totalDesignCount.toLocaleString(document.documentElement.lang),
                });
                $(document).trigger('dataPaginationUpdate', {
                    pagination: data.pagination,
                    preventScrollTop,
                });
                $(document).trigger('dataCanonicalUrlUpdate', { url: data.canonical_url });
                $(document).trigger('dataPageHeaderUpdate', {
                    page_header_text: data.page_header_text,
                    page_title_text: data.page_title_text,
                });
            },
            complete() {
                if (!hideSpinner) {
                    $(document).trigger('dataBrowseEnd');
                }
            },
        });
    };

    this.initFilters = function(event, data) {
        data.filters.forEach(function(el) {
            this.addElementToFilterData(el);
        }, this);
        this.setPageFilter(data);
    };

    this.setPageFilter = function(filterData) {
        if (!this.hasPageFilter(filterData)) {
            this.attr.filters.page = { value: '' };
        }
    };

    this.addFilters = function(event, data) {
        // Cache filter data to compare with updated filters later. stringify+parse = clone
        const oldFilters = JSON.parse(JSON.stringify(this.attr.filters));
        data.filters.forEach(function(el) {
            this.addElementToFilterData(el);
        }, this);

        this.setPageFilter(data);

        if (!this.compareObjects(oldFilters, this.attr.filters)) {
            this.emitFilterChange();
        }
    };

    this.replaceFilters = function(event, data) {
        this.attr.filters = data.filters;
        this.trigger('dataFilterChange', { filters: this.attr.filters });
    };

    this.hasPageFilter = function(data) {
        return data.filters.some(filter => filter.name === 'page' && +filter.value > 1);
    };

    this.arrayContainsObject = function(array, object) {
        for (let i = 0; i < array.length; i += 1) {
            if (JSON.stringify(array[i]) === JSON.stringify(object)) {
                return true;
            }
        }
        return false;
    };

    this.createUniqueArray = function(array) {
        return array.reduce((p, c) => {
            if (!this.arrayContainsObject(p, c)) {
                p.push(c);
            }
            return p;
        }, []);
    };

    this.addElementToFilterData = function(el) {
        if (this.isArrayParam(el.name)) {
            if (this.attr.filters[el.name]) {
                this.attr.filters[el.name].push({
                    title: el.title,
                    value: el.value,
                });
                this.attr.filters[el.name] = this.createUniqueArray(this.attr.filters[el.name]);
            } else {
                this.attr.filters[el.name] = [
                    {
                        title: el.title,
                        value: el.value,
                    },
                ];
            }
        } else {
            this.attr.filters[el.name] = {
                title: el.title,
                value: el.value,
            };
        }
    };

    this.removeElementFromFilterData = function(el) {
        if (this.isArrayParam(el.name)) {
            if (this.attr.filters[el.name]) {
                this.removeElementFromFilterArray({
                    name: el.name,
                    value: el.value,
                });
            }
        } else {
            this.attr.filters[el.name] = { value: '' };
        }
    };

    this.filterIndexInArray = function(array, object) {
        for (let i = 0; i < array.length; i += 1) {
            if (array[i].name === object.name && array[i].value === object.value) {
                return i;
            }
        }
        return false;
    };

    this.removeElementFromFilterArray = function(filter) {
        const index = this.filterIndexInArray(this.attr.filters[filter.name], {
            value: filter.value,
        });
        if (index !== false) {
            this.attr.filters[filter.name].splice(index, 1);
        }
    };

    this.makeQueryString = function() {
        const filters = this.removeEmptyFilters(this.attr.filters);
        return this.filtersToQueryString(filters);
    };

    this.filterByLikesEnabled = function() {
        const filters = this.removeEmptyFilters(this.attr.filters);
        if (filters['your-likes'] && filters['your-likes'][0].value === 'true') {
            return true;
        }
        return false;
    };

    this.queryStringToJSON = function() {
        const pairs = location.search.slice(1).split('&');
        const result = {};
        let idx;

        for (idx in pairs) {
            // eslint-disable-line guard-for-in, no-restricted-syntax
            const pair = pairs[idx].split('=');
            const key = decodeURIComponent(pair[0].toLowerCase());
            const value = decodeURIComponent(pair[1] || '');

            if (key) {
                if (this.isArrayParam(key)) {
                    result[key] = result[key] || [];
                    value.split(',').forEach(el => {
                        result[key].push(el);
                    });
                } else {
                    result[key] = value;
                }
            }
        }
        return result;
    };

    this.filtersToQueryString = function(filters) {
        const queries = [];
        for (const filtersIndex in filters) {
            // eslint-disable-line guard-for-in, no-restricted-syntax
            const filter = filters[filtersIndex];
            const query = [];
            for (const filterIndex in filter) {
                // eslint-disable-line guard-for-in, no-restricted-syntax
                if (filter[filterIndex].value) {
                    query.push(filter[filterIndex].value);
                }
            }
            queries.push(`${filtersIndex}=${query.toString()}`);
        }
        return queries.join('&');
    };

    this.isArrayParam = function(param) {
        return this.attr.filterTypes[param.replace('[]', '')] === 'array';
    };

    this.compareObjects = function(obj1, obj2) {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    };

    this.removeFilters = function(event, data) {
        // Cache filter data to compare with updated filters later. stringify+parse = clone
        const oldFilters = JSON.parse(JSON.stringify(this.attr.filters));
        data.filters.forEach(el => {
            this.removeElementFromFilterData(el);
        });
        this.attr.filters.page = { value: '' };
        if (!this.compareObjects(oldFilters, this.attr.filters)) {
            this.emitFilterChange();
        }
    };

    this.removeEmptyFilters = function(filters) {
        const self = this;
        const cleanedFilters = {};
        let filtersIndex;
        let filter;

        for (filtersIndex in filters) {
            // eslint-disable-line guard-for-in, no-restricted-syntax
            filter = filters[filtersIndex];

            if (self.isArrayParam(filtersIndex)) {
                for (const filterIndex in filter) {
                    // eslint-disable-line guard-for-in, no-restricted-syntax
                    const filterItem = filter[filterIndex];
                    if (filterItem.value && filterItem.value.length) {
                        cleanedFilters[filtersIndex] = cleanedFilters[filtersIndex] || [];
                        cleanedFilters[filtersIndex].push(filterItem);
                    }
                }
            } else if (filter.value && filter.value.length) {
                cleanedFilters[filtersIndex] = cleanedFilters[filtersIndex] || [];
                cleanedFilters[filtersIndex].push(filter);
            }
        }

        return cleanedFilters;
    };

    this.emitFilterChange = function() {
        this.updateHistory();
        this.getBrowseDesigns();
        this.trigger('dataFilterChange', { filters: this.attr.filters });
    };

    this.removeAllFilters = function() {
        for (const key in this.attr.filters) {
            // eslint-disable-line guard-for-in, no-restricted-syntax
            this.attr.filters[key] = this.isArrayParam(key) ? [] : '';
        }
        this.attr.filters.page = { value: '' };
        this.emitFilterChange();
    };

    // History

    this.historyPopped = function(data) {
        let filtersWithoutTitles;
        let newFilters;
        let query;
        let filtersToBe;

        if ('state' in data.originalEvent && data.originalEvent.state !== null) {
            query = this.queryStringToJSON();
            newFilters = this.filtersFromQuery(query);
            filtersWithoutTitles = this.filtersWithoutTitles(this.attr.filters);

            if (!this.compareObjects(filtersWithoutTitles, newFilters)) {
                filtersToBe = this.handleUndefinedQueryKeys(query, newFilters);
                this.attr.filters = filtersToBe;
                this.getBrowseDesigns();
            }

            this.trigger('dataNeedsFilterTitles', { filters: this.attr.filters });
        }
    };

    this.filtersFromQuery = function(query) {
        let key;
        const filters = Object.assign({}, this.attr.filters);
        // Set default values in case query does not have keys
        // E.G. Hitting browser back button from page 2.
        filters['max-age'] = { value: '' };
        filters.page = { value: '' };

        for (key in query) {
            // eslint-disable-line no-restricted-syntax
            if (this.isArrayParam(key)) {
                filters[key] = [];
                query[key].forEach(function(value) {
                    // eslint-disable-line no-loop-func, prefer-arrow-callback
                    filters[key].push({ value });
                }, this);
            } else {
                filters[key] = { value: query[key] };
            }
        }

        return filters;
    };

    // Return clone of this.attr.filters without titles so that
    // it can be compared with this.filtersFromQuery(query);
    this.filtersWithoutTitles = function(filters) {
        let key;
        const newFilters = Object.assign({}, filters);

        for (key in newFilters) {
            // eslint-disable-line no-restricted-syntax
            if (this.isArrayParam(key)) {
                newFilters[key].forEach(function(value) {
                    // eslint-disable-line no-loop-func, prefer-arrow-callback
                    delete value.title; // eslint-disable-line no-param-reassign
                    if (!newFilters[key] || !newFilters[key] === 1) {
                        newFilters[key] = { value: '' };
                    }
                });
            } else {
                delete newFilters[key].title;
            }
        }
        return newFilters;
    };

    // If a filter key isn't defined in query, set it as an empty array or string.
    this.handleUndefinedQueryKeys = function(query, filters) {
        let key;

        for (key in filters) {
            // eslint-disable-line no-restricted-syntax
            if (typeof query[key] === 'undefined') {
                filters[key] = this.isArrayParam(key) ? [] : { value: '' }; // eslint-disable-line no-param-reassign
            }
        }
        return filters;
    };

    this.updateHistory = function() {
        if (this.isHistoryApiSupported()) {
            this.pushHistory(`${this.attr.baseUrl}?${this.makeQueryString()}`);
        } else {
            window.location = `${this.attr.baseUrl}?${this.makeQueryString()}`;
        }
    };
}

export default defineComponent(BrowseDesigns, withHistory);



// WEBPACK FOOTER //
// ./src/js/component_data/browse-designs.js